import { ModuleWithProviders, NgModule } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NProductConfiguration } from './df-module-product-configuration.interfaces';

@NgModule()
export class DfModuleProductConfigurationModule {
    static forRoot(config?: DeepPartial<NProductConfiguration.IModuleOptions>): ModuleWithProviders<DfModuleProductConfigurationModule> {
        return {
            ngModule: DfModuleProductConfigurationModule,
            providers: [
                {
                    provide: NProductConfiguration.OPTIONS,
                    useFactory: () => {
                        return defaultsDeep(config || {}, <NProductConfiguration.IModuleOptions>{
                            bundle: {},
                            configurable: {
                                order: [],
                                optionsEngines: [],
                                selection: {
                                    default: {
                                        onMismatch: 'unselect',
                                        onPartial: 'parent'
                                    }
                                },
                                metaModel: 'none',
                                urlModel: 'none',
                                chooseChild: (matchResult, selection) => matchResult.children[0]
                            }
                        });
                    }
                }
            ]
        };
    }
}
